export default __webpack_public_path__ + "static/media/Ultimate-Gurudakshna.fce6bcd6.jpg";